import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {JudgeModel} from '@/models/judge.model';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'judges';

// @ts-ignore
if (store.state.juges) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class JudgesStoreModule extends EntityStateAdapter<JudgeModel> {

  get judges(): JudgeModel[] {
    return this._entities;
  }

  @Action({commit: 'insertMany', rawError: true})
  fetchAll(challengeId: number): Promise<JudgeModel[]> {
    return (new ChallengesApi())
      .findJudges(challengeId)
      .pipe(take(1))
      .toPromise()
  }
}
